import { type ReactElement, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { Mention, MentionsInput } from 'react-mentions';
import type { UndecoratedUser } from '@witmetrics/utils';
import { formatUserName } from '@witmetrics/utils/strings';
import Box from '@/components/Box';
import { classes, styles } from './utils';

export type MentionTextFieldProps = {
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  placeholder?: string;
  value: string;
  users: UndecoratedUser[];
  onChange: (value: string) => void;
};

export default function MentionTextField({
  disabled,
  autoFocus,
  className,
  placeholder,
  value,
  users,
  onChange,
}: MentionTextFieldProps) {
  const suggestionsWrapperRef = useRef<HTMLDivElement>(null);

  return (
    <Box sx={styles.wrapper} className={twMerge(classes.wrapper, className)}>
      {/* @ts-ignore */}
      <MentionsInput
        allowSpaceInQuery
        allowSuggestionsAboveCursor
        disabled={disabled}
        autoFocus={autoFocus}
        className={classes.input}
        value={value}
        placeholder={placeholder}
        suggestionsPortalHost={suggestionsWrapperRef.current ?? undefined}
        customSuggestionsContainer={(children) => (
          <div className={classes.suggestionsList}>
            {children as ReactElement}
          </div>
        )}
        onChange={(e) => onChange(e.target.value)}>
        <Mention
          appendSpaceOnAdd
          trigger="@"
          data={users.map((user) => ({
            id: user.id,
            display: formatUserName(user),
          }))}
          // NOTE: Giving extra space as a workaround for padding
          displayTransform={(id, display) => `  @${display} `}
          renderSuggestion={(suggestion) => (
            <div className={classes.suggestion}>{suggestion.display}</div>
          )}
        />
      </MentionsInput>
      <Box ref={suggestionsWrapperRef} sx={styles.suggestionsWrapper} />
    </Box>
  );
}
